import React from 'react';
import { FaSnowflake, FaStar } from 'react-icons/fa';
import { FiArrowUpRight, FiArrowRight } from 'react-icons/fi';

const CoolingPerformance = () => {
  const subMetrics = [
    { label: 'Recovery Performance', value: 'Excellent', color: 'text-emerald-600' },
    { label: 'Temperature Stability', value: 'Excellent', color: 'text-emerald-600' },
    { label: 'Efficiency Trend (7 Days)', value: 'Improving', color: 'text-emerald-600', icon: FiArrowUpRight }
  ];

  return (
    <div className="w-full max-w-sm bg-white border border-gray-100 rounded-2xl p-5 font-sans shadow-[0_2px_12px_rgba(0,0,0,0.01)] flex flex-col justify-between min-h-[360px] select-none">
      <div>
        {/* Title & Icon Header */}
        <div className="flex items-center gap-2 mb-4">
          <FaSnowflake className="w-4 h-4 text-blue-500" />
          <h3 className="text-[15px] font-bold text-gray-800 tracking-tight">
            Cooling Performance
          </h3>
        </div>

        {/* Rating Stars Frame Layout */}
        <div className="space-y-1 mb-6">
          <div className="flex items-center gap-0.5 text-emerald-500">
            {[...Array(5)].map((_, i) => <FaStar key={i} className="w-4 h-4 fill-current" />)}
          </div>
          <h4 className="text-[15px] font-extrabold text-gray-900">Excellent</h4>
        </div>

        {/* Data List Rows */}
        <div className="space-y-3.5 border-t border-gray-50 pt-4">
          {subMetrics.map((item, idx) => {
            const TrendIcon = item.icon;
            return (
              <div key={idx} className="flex items-center justify-between text-[12px]">
                <span className="font-semibold text-gray-400">{item.label}</span>
                <div className={`flex items-center gap-0.5 font-bold ${item.color}`}>
                  <span>{item.value}</span>
                  {TrendIcon && <TrendIcon className="w-3.5 h-3.5 stroke-[2.5]" />}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Navigation Trigger Footer */}
      <button className="w-full flex items-center justify-between text-[#0052FF] font-bold text-[12px] hover:opacity-80 transition-opacity border-t border-gray-50 pt-4 mt-6 group cursor-pointer">
        <span>View performance details</span>
        <FiArrowRight className="w-3.5 h-3.5 transition-transform group-hover:translate-x-0.5 stroke-[2.5]" />
      </button>
    </div>
  );
};

export default CoolingPerformance;
